import React from 'react';
import { Link } from 'react-router-dom';
import { formatHelpDate, getHelpArticlePath } from './helpFormat';

const PressList = ({ items, linkState }) => (
  <ul className="help-card-list">
    {items.map(item => (
      <li key={item.id}>
        <Link to={getHelpArticlePath(item.id)} state={linkState} className="help-card">
          <time className="help-card__date" dateTime={item.date}>{formatHelpDate(item.date)}</time>
          <h2 className="help-card__title">{item.title}</h2>
          {item.summary && <p className="help-card__summary">{item.summary}</p>}
          {item.sources?.length > 0 && (
            <div className="help-card__chips">
              {item.sources.map(source => (
                <span key={source.name} className="help-chip">{source.name}</span>
              ))}
            </div>
          )}
        </Link>
      </li>
    ))}
  </ul>
);

export default PressList;
